import { AddToCart } from 'components'

const Product = {
  el: {
    form: document.querySelectorAll<HTMLFormElement>('.product__add-form'),
    qtyBubble: document.querySelector<HTMLElement>('.top__qty'),
    cartModal: document.querySelector<HTMLElement>('.cart-modal'),
    stockMessage: document.querySelector<HTMLElement>('.product__stock-message'),
  },

  init() {
    if (this.el.form) {
      Array.prototype.forEach.call(this.el.form, (item: HTMLFormElement) => {
        const button = item.querySelector<HTMLButtonElement>('.product__add-button')
        const qty = item.querySelector<HTMLInputElement>('[name=quantity]')

        item.addEventListener('submit', (e) => {
          e.preventDefault()
          this.add(item, qty.value, 0, button)
        })
      })
    }
  },

  showCartModal() {
    this.el.cartModal.classList.add('open')
  },

  async add(form: HTMLFormElement, qty?, direction?, button?) {
    const adder = AddToCart(
      button,
      form,
    )

    if (this.el.stockMessage) {
      this.el.stockMessage.style.display = 'none'
    }

    await adder.then(response => {
      if (response.status === 200)
      {
        this.updateCartBubble(qty, direction)
        return
      }
      if (response.status === 409) {
        if (this.el.stockMessage) {
          this.el.stockMessage.style.display = 'block'
        }
        return
      }
      else if (response.status === 403) {
        this.showCartModal()
        return
      }
    })
  },

  updateCartBubble(qty, direction?: Number) {
    if (!this.el.qtyBubble.classList.contains('top__qty--visible')) {
      this.el.qtyBubble.classList.add('top__qty--visible')
    }

    const currentTotal = parseInt(this.el.qtyBubble.innerHTML)

    if (direction === 1) {
      this.el.qtyBubble.innerHTML = (currentTotal - parseInt(qty)).toString()
    }

    if (direction === 0) {
      this.el.qtyBubble.innerHTML = (currentTotal + parseInt(qty)).toString()
    }
  },
}

export default Product
